<script setup lang="ts">

</script>

<template>
  <p class="text-base leading-relaxed">
    <slot></slot>
  </p>
</template>
